import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import styled from 'styled-components';
import RegistrationAuth from '~/App/shared/components/Auth/Registration';
import { getRegistrationTitle } from '~/App/shared/components/Auth/Registration/registrationHelpers';
import Head from '~/App/shared/components/Head';
import ComponentPadding from '~/App/shared/components/Layout/ComponentPadding';
import { translateRoute } from '~/App/shared/localization';
import { useTranslation } from '~/Locale';
import useCanonicalUrl from '~/App/shared/hooks/useCanonicalUrl';

const MaxWidth = styled.div`
  max-width: 420px;
  margin: 0 auto;
  padding-inline: 2rem;
`;

interface Props {
  tab: 'company' | 'private';
}

const Registration = ({ tab }: Props) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const canonicalUrl = useCanonicalUrl(pathname);
  const { t } = useTranslation();

  const privatePath = translateRoute(
    t,
    '/ROUTES.MEMBER/ROUTES.MEMBER_REGISTER_PRIVATE'
  );

  const organizationPath = translateRoute(
    t,
    '/ROUTES.MEMBER/ROUTES.MEMBER_REGISTER_ORGANIZATION'
  );

  const isCompany = tab === 'company';
  const title = getRegistrationTitle(isCompany, t);

  const onPrivateClick = useCallback(() => {
    history.push(privatePath);
  }, [history, privatePath]);

  const onCompanyClick = useCallback(() => {
    history.push(organizationPath);
  }, [history, organizationPath]);

  return (
    <>
      <Head title={title} link={[{ rel: 'canonical', href: canonicalUrl }]} />

      <ComponentPadding>
        <MaxWidth>
          <RegistrationAuth
            showDescription
            initialTab={tab}
            onClose={() => history.push('/')}
            onPrivateClick={onPrivateClick}
            onCompanyClick={onCompanyClick}
            isStandaloneView
          />
        </MaxWidth>
      </ComponentPadding>
    </>
  );
};

export default Registration;
